<div class="flex pt-9 pr-6 flex-col h-full overflow-hidden">
  <section class="logo-section">
    <cp-logo></cp-logo>
  </section>

  <section class="back-actions-container">
    <div class="go-back-container">
      <go-back [routerLink]="['/dashboard/users']"></go-back>
    </div>

    <div class="actions-container">
      <gbui-button class="buttons-outline clear" (click)="importFile()"
        >Import File</gbui-button
      >
      <gbui-button
        [busy]="addMultipleMembersLoading$ | async"
        class="buttons-outline"
        (click)="submitForms()"
        >Send Link</gbui-button
      >
    </div>
    <h1 class="text-green-dark">Add users</h1>
  </section>

  <div class="grow overflow-auto">
    <section class="select-sections-container">
      <div class="section-selector-container">
        <h3
          (click)="changeSection('requester')"
          [ngClass]="{ selected: section == 'requester' }"
          class="selected"
        >
          Requesters
        </h3>
        <h3
          (click)="changeSection('approver')"
          [ngClass]="{ selected: section == 'approver' }"
          for=""
        >
          Approvers
        </h3>
      </div>
    </section>

    <ng-container *ngIf="section == 'requester'">
      <div *ngFor="let form of requestersForms; let i = index">
        <form [formGroup]="form">

          <div class="input-container">
            <label class="input-label">Email</label>
            <input
              (keydown)="changeStatus(form.controls['email'].value, i)"
              class="simulate-input"
              type="text"
              [value]="form.value.email"
              formControlName="email"
              placeholder="Enter the email"
              [ngClass]="{
                'invalid-input':
                  (!form.controls['email'].valid &&
                    (form.controls['email'].touched || submitted)) ||
                  isThisDuplicated(form.controls['email'].value) ||
                  alreadyExists(form.controls['email'].value)
              }"
            />
            <label
              class="scale-up-ver-top"
              *ngIf="
                !form.controls['email'].valid &&
                (form.controls['email'].touched || submitted)
              "
            >
              Invalid Email
            </label>
            <label
              class="scale-up-ver-top"
              *ngIf="isThisDuplicated(form.controls['email']?.value)"
            >
              Duplicated
            </label>
            <label
              class="scale-up-ver-top"
              *ngIf="alreadyExists(form.controls['email']?.value)"
            >
              Email Already Exists
            </label>
          </div>

          <div class="input-container remove-button-wrapper">
            <gbui-button (click)="removeForm(i)" class="buttons-outline">
              Remove
            </gbui-button>
          </div>
        </form>
      </div>
    </ng-container>

    <!--
      **
      * Approvers
      **
     -->
    <ng-container *ngIf="section == 'approver'">
      <div *ngFor="let form of approversForms; let i = index">
        <form [formGroup]="form">

          <div class="input-container">
            <label class="input-label">Email</label>
            <input
              (keydown)="changeStatus(form.controls['email'].value, i)"
              class="simulate-input"
              type="text"
              [value]="form.value.email"
              formControlName="email"
              placeholder="Enter the email"
              [ngClass]="{
                'invalid-input':
                  (!form.controls['email'].valid &&
                    (form.controls['email'].touched || submitted)) ||
                  isThisDuplicated(form.controls['email'].value) ||
                  alreadyExists(form.controls['email'].value)
              }"
            />
            <label
              class="scale-up-ver-top"
              *ngIf="
                !form.controls['email'].valid &&
                (form.controls['email'].touched || submitted)
              "
            >
              Invalid Email
            </label>
            <label
              class="scale-up-ver-top"
              *ngIf="isThisDuplicated(form.controls['email'].value)"
            >
              Duplicated
            </label>
            <label
              class="scale-up-ver-top"
              *ngIf="alreadyExists(form.controls['email'].value)"
            >
              Email Already Exists
            </label>
          </div>

          <div class="input-container remove-button-wrapper">
            <gbui-button (click)="removeForm(i)" class="buttons-outline">
              Remove
            </gbui-button>
          </div>
        </form>
      </div>
    </ng-container>
    <section class="show-more-button">
      <gbui-button class="buttons-outline" (click)="addForm()">
        {{ formsArrApprovers.length == 20 ? "Show Less" : "Show More" }}
      </gbui-button>
    </section>
  </div>
</div>
